// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/.0.28.5@css-loader/index.js?sourceMap!../../../node_modules/.13.0.4@vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6677980b\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/.6.0.6@sass-loader/lib/loader.js!./basic.scss");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../node_modules/.3.0.1@vue-style-loader/lib/addStylesClient.js")("0a8d7402", content, false);
// Hot Module Replacement
if(module.hot) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/.0.28.5@css-loader/index.js?sourceMap!../../../node_modules/.13.0.4@vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6677980b\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/.6.0.6@sass-loader/lib/loader.js!./basic.scss", function() {
     var newContent = require("!!../../../node_modules/.0.28.5@css-loader/index.js?sourceMap!../../../node_modules/.13.0.4@vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6677980b\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/.6.0.6@sass-loader/lib/loader.js!./basic.scss");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/.3.0.1@vue-style-loader!./node_modules/.0.28.5@css-loader?sourceMap!./node_modules/.13.0.4@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6677980b","scoped":false,"hasInlineConfig":false}!./node_modules/.6.0.6@sass-loader/lib/loader.js!./example/assets/style/basic.scss
// module id = 226
// module chunks = 5